import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reports: {
		id: 'spa-apps-software-reports-deployment-frequency-report.reports',
		defaultMessage: 'Reports',
		description: 'Title of a section',
	},
	browserTitle: {
		id: 'spa-apps-software-reports-deployment-frequency-report.browser-title',
		defaultMessage: 'Deployment frequency',
		description: 'The title of a report that shows how frequently the team deploy changes',
	},
});
